import store from '@/store/store';
import mutationType from '@/store/mutation-types';
import breadCrumb from '@/store/breadCrumb';
import Vue from 'vue';
import Router from 'vue-router';
import {authUtil} from '@/util/plugins'
import gtSuccess from '@/components/billing/success/gt-success.vue';
import gtWarn from '@/components/billing/warn/gt-warn.vue';
import gtError from '@/components/billing/error/gt-error.vue';

//-------
import home from '@/components/home.vue';
//-------
import authorizeApi from '@/api/authorize/authorizeApi';

import Profile from '@/model/common/profile';
//首頁
import functionList from '@/components/functionList/functionList.vue';

//profile
import profile from '@/components/profile/profile.vue'

import redirect from '@/components/redirect/redirect.vue';

// 資費試算
import ratePlanSimulation from '@/components/ratePlanSimulation/ratePlanSimulation.vue';
import ratePlanCalculation from '@/components/ratePlanSimulation/ratePlanCalculation.vue';

//無紙化帳單
import eBill from '@/components/eBill/eBill.vue';
import eBillHome from '@/components/eBill/eBillHome.vue';
//eBill申請
import eBillApply1 from '@/components/eBill/eBillApply/eBillApply1.vue'
import eBillApply2 from '@/components/eBill/eBillApply/eBillApply2.vue'
import eBillApply3 from '@/components/eBill/eBillApply/eBillApply3.vue'
import eBillApplyResult from '@/components/eBill/eBillApply/eBillApplyResult.vue'
//更改eBill方式
import eBillMutiApplied from '@/components/eBill/eBillCancel/eBillMutiApplied.vue'
import eBillCancel from '@/components/eBill/eBillCancel/eBillCancel.vue'
import eBillCancelResult from '@/components/eBill/eBillCancel/eBillCancelResult.vue'
//更改簡訊寄送門號
import eBillChangeSMS from '@/components/eBill/eBillChangeSMS/eBillChangeSMS.vue'
import eBillChangeSMS2 from '@/components/eBill/eBillChangeSMS/eBillChangeSMS2.vue'
import eBillChangeSMSResult from '@/components/eBill/eBillChangeSMS/eBillChangeSMSResult.vue'
//更改Mail寄送位址
import eBillChangeeMail from '@/components/eBill/eBillChangeeMail/eBillChangeeMail.vue'
import eBillChangeeMail2 from '@/components/eBill/eBillChangeeMail/eBillChangeeMail2.vue'
import eBillChangeeMailResult from '@/components/eBill/eBillChangeeMail/eBillChangeeMailResult.vue'
//資費方案異動
import changeVoiceTariff4G from '@/components/changeVoiceTariff4G/changeVoiceTariff4G.vue'
import changeVoiceTariffResult4G from '@/components/changeVoiceTariff4G/changeVoiceTariffResult4G.vue'
//展延信用卡轉帳代繳期限
import billCreditCardSuccess from '@/components/billCreditCard/billCreditCardSuccess.vue'
import billCreditCard from '@/components/billCreditCard/billCreditCard.vue'
//帳單查詢
import billQueryMonth from '@/components/billQuery/billQueryMonth.vue'
import billQueryResult from '@/components/billQuery/billQueryResult.vue'
import billQueryRedirect from '@/components/billQuery/billQueryRedirect.vue'

//修改帳單地址
import changeBillAddress from '@/components/changeBillAddress/changeBillAddress.vue'

// 未出帳查詢
import unBilledQuery from '@/components/unBilledQuery/unBilledQuery.vue'

// 補寄帳單申請
import billRequest from '@/components/billRequest/billRequest.vue'
import billRequestApply from '@/components/billRequest/billRequestApply.vue'
import billRequestResult from '@/components/billRequest/billRequestResult.vue'
import billRequestConfirm from '@/components/billRequest/billRequestConfirm.vue'
//通話明細申請
import billLog from '@/components/billLog/billLog.vue'
import billLogEMail from '@/components/billLog/billLogEMail.vue'
import billLogMailCheck from '@/components/billLog/billLogMailCheck.vue'
import billLogMailResult from '@/components/billLog/billLogMailResult.vue'
import billLogEMailCheck from '@/components/billLog/billLogEMailCheck.vue'
import billLogEMailResult from '@/components/billLog/billLogEMailResult.vue'
import billLogGetBillSuccess from '@/components/billLog/billLogGetBillSuccess.vue'
import basicHome from '@/components/basicHome.vue'

Vue.use(Router);

const router = new Router({
	// scrollBehavior (to, from, savedPosition) {
	// 	return { x: 0, y: 0 }
	// },
	// mode: 'history',
	routes: [
        // home without sideBar
		{
			path: '/basicHome',
			name: 'basicHome',
			component: basicHome,
			children: []
        },
		{
			path: '',
			name: 'home',
			redirect: '/functionList',
			component: home,
			children: [{
					path: 'success',
					name: 'gt-success',
					props: true,
					component: gtSuccess,
                },
				{
					path: 'warn',
					name: 'gt-warn',
					props: true,
					component: gtWarn,
                },
				{
					path: 'error',
					name: 'gt-error',
					props: true,
					component: gtError,
                },
				{
					path: 'redirect',
					name: 'redirect',
					props: true,
					component: redirect,
                },
                //無紙化帳單 eBill
				{
					path: 'eBill/:applyOption',
					name: 'eBill',
					props: true,
					component: eBill,
					children: [{
							path: 'eBillHome',
							name: 'e-bill-home',
							props: true,
							component: eBillHome,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
                        // 無紙化帳單申請
						{
							path: 'eBillApply1',
							name: 'e-bill-apply1',
							props: true,
							component: eBillApply1,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillApply2',
							name: 'e-bill-apply2',
							props: true,
							component: eBillApply2,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillApply3',
							name: 'e-bill-apply3',
							props: true,
							component: eBillApply3,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillApplyResult',
							name: 'e-bill-apply-result',
							props: true,
							component: eBillApplyResult,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
                        //更改帳單寄送方式
						{
							path: 'eBillMutiApplied',
							name: 'e-bill-muti-applied',
							props: true,
							component: eBillMutiApplied,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillCancel',
							name: 'e-bill-cancel',
							props: true,
							component: eBillCancel,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillCancelResult',
							name: 'e-bill-cancel-result',
							props: true,
							component: eBillCancelResult,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
                        //更改簡訊寄送門號
						{
							path: 'eBillChangeSMS',
							name: 'e-bill-change-sms',
							props: true,
							component: eBillChangeSMS,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillChangeSMS2',
							name: 'e-bill-change-sms2',
							props: true,
							component: eBillChangeSMS2,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillChangeSMSResult',
							name: 'e-bill-change-sms-result',
							props: true,
							component: eBillChangeSMSResult,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
                        //更改mail寄送位址
						{
							path: 'eBillChangeeMail',
							name: 'e-bill-change-email',
							props: true,
							component: eBillChangeeMail,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillChangeeMail2',
							name: 'e-bill-change-email2',
							props: true,
							component: eBillChangeeMail2,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
						{
							path: 'eBillChangeeMailResult',
							name: 'e-bill-change-email-result',
							props: true,
							component: eBillChangeeMailResult,
							meta: {
								breadCrumb: [breadCrumb.BILL]
							}
                        },
                    ]
                },
                // 首頁
				{
					path: 'functionList',
					name: 'function-list',
					component: functionList,
					props: true
                },
                //資費方案異動
				{
					path: 'changeVoiceTariff4G',
					name: 'change-voice-tariff-4G',
					props: true,
					component: changeVoiceTariff4G,
					meta: {
						breadCrumb: [breadCrumb.CONTRACT]
					}
                },
				{
					path: 'changeVoiceTariff4G/result',
					name: 'change-voice-tariff-result-4G',
					props: true,
					component: changeVoiceTariffResult4G,
					meta: {
						breadCrumb: [breadCrumb.CONTRACT]
					}
                },
                //展延信用卡轉帳代繳期限
				{
					path: 'billCreditCard',
					name: 'bill-credit-card',
					props: true,
					component: billCreditCard,
					meta: {
						breadCrumb: [breadCrumb.BILL, breadCrumb.PAYMENT]
					}
                },
				{
					path: 'billCreditCard/success',
					name: 'bill-credit-card-success',
					props: true,
					component: billCreditCardSuccess,
					meta: {
						breadCrumb: [breadCrumb.BILL, breadCrumb.PAYMENT]
					}
                },
                //帳單查詢
                {
                    path: 'billQueryMonth',
                    name: 'bill-query-month',
                    props: true,
					component: billQueryMonth,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
                {
                    path: 'billQueryResult',
                    name: 'bill-query-result',
                    props: true,
					component: billQueryResult,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billQueryRedirect',
					name: 'bill-Query-Redirect',
					props: true,
					component: billQueryRedirect,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
				},
                //修改帳單地址
				{
					path: 'changeBillAddress',
					name: 'change-bill-address',
					props: true,
					component: changeBillAddress,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
                // 未出帳查詢
				{
					path: 'unBilledQuery',
					name: 'un-billed-query',
					props: true,
					component: unBilledQuery,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
                // 補寄帳單申請
				{
					path: 'billRequest',
					name: 'bill-request',
					props: true,
					component: billRequest,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billRequestApply',
					name: 'bill-request-apply',
					props: true,
					component: billRequestApply,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billRequestResult',
					name: 'bill-request-result',
					props: true,
					component: billRequestResult,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billRequestConfirm',
					name: 'bill-request-confirm',
					props: true,
					component: billRequestConfirm,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
                // 資費試算
				{
					path: 'ratePlanSimulation',
					name: 'rate-plan-simulation',
					props: true,
					component: ratePlanSimulation,
					meta: {
						breadCrumb: [breadCrumb.CONTRACT]
					}
                },
                // 通話明細申請
				{
					path: 'billLog',
					name: 'bill-log',
					props: true,
					component: billLog,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogEMail',
					name: 'bill-log-email',
					props: true,
					component: billLogEMail,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogMailCheck',
					name: 'bill-log-mail-check',
					props: true,
					component: billLogMailCheck,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogMailResult',
					name: 'bill-log-mail-result',
					props: true,
					component: billLogMailResult,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogEMailCheck',
					name: 'bill-log-email-check',
					props: true,
					component: billLogEMailCheck,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogEMailResult',
					name: 'bill-log-email-result',
					props: true,
					component: billLogEMailResult,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                },
				{
					path: 'billLogGetBillSuccess',
					name: 'bill-log-get-bill-success',
					props: true,
					component: billLogGetBillSuccess,
					meta: {
						breadCrumb: [breadCrumb.BILL]
					}
                }
            ]
        },
		// { path: '/', redirect: '' },

		{
			path: '*',
			name: 'gt-error-404',
        },
    ],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return { selector: to.hash };
		}
		return { x: 0, y: 0 };
	}
});

router.beforeEach(async (to, from, next) => {

	if (!to.path.startsWith('/redirect') && !to.path.startsWith('/error')) {
		sessionStorage.setItem('historyPage', `${window.location.pathname}#${to.fullPath}`);
	}

	if (to.name === 'gt-error-404') {
		location.replace(process.env.PAGE_404);
	}

	// 加入麵包屑的值
	store.commit(mutationType.breadCrumb, to.meta.breadCrumb);

	// 加入此處的功能不需要登入即可進入
	let notLoginNames = ['function-list', 'bill-log-get-bill-success', 'gt-error'];

	// 判斷使用者資訊
	try {
    const profile = new Profile();
    await authorizeApi.auth();
		if (notLoginNames.indexOf(to.name) > -1) {
			// 若即將前往的頁面包含於不需登入功能之中
			if (!store.state.profile.name && sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfile();
				if(result){
					saveUserProfile(result);
				} else {
					return;
				}
			} else if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfileNotRedirect();
				if(result && result.code != 401){
					saveUserProfile(result);
				}
			}
		} else {
			if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfile();
				if(result){
					saveUserProfile(result);
				} else {
					return;
				}
			}
		}
	} catch (error) {
		console.log('error=', error)
		location.replace(process.env.MAIN_PAGE);
		return;
  }

  if(!store.state.profile.visit){
    store.commit(mutationType.profile, {visit: true});
  }
	next();
});

function saveUserProfile(userProfile) {
	const profile = new Profile();
	profile.buildFromObject(userProfile);
	store.commit(mutationType.profile, profile);
	// 給 auth() 使用
	authUtil.setSessionStorage({
		loginType: 'cas',
		option: {
			productType: userProfile.productType,
			contractStatus: userProfile.contractStatus,
			identity: authUtil.getIdentity(userProfile.pid)
		}
	})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js